import { actionCreatorFactory } from 'typescript-fsa'
import { Admin } from '../../types'

const actionCreator = actionCreatorFactory()

export const receiveAdmin = actionCreator<Admin>('receiveAdmin')
export const cleanAdmin = actionCreator('cleanAdmin')
